import { BoxProps, ColorOptions, TextProps } from '@jfs/ui-new'

export const shadowStyle = {
  shadowColor: 'GRAY_SHADOW',
  shadowOffset: {
    width: 1,
    height: 2,
  },
  shadowOpacity: 1,
  shadowRadius: 2,
  zIndex: 1,
}

const customTheme = {
  colors: {
    PRIMARY: '#0186B0',
    PRIMARY_STORNG: '#027699',
    PRIMARY_LIGHT: '#F0F8FB',
    JIO_PRIMARY: '#214796' as ColorOptions,
    JIO_PRIMARY_ALPHA: 'rgb(74,104,169)' as ColorOptions,
    JIO_SECONDARY_ALPHA: 'rgb(119,142,190)' as ColorOptions,
    BLUE_LIGHT_ALPHA: 'rgb(58,83,152)' as ColorOptions,
  },
}

const styles = {
  container: (isMobile: boolean) =>
    ({
      f: 1,
      bg: 'LIGHTEST_GREY',
      ph: isMobile ? 0 : 16,
      pt: isMobile ? 0 : 16,
      pb: isMobile ? 0 : 16,
    } as BoxProps),
  borderedBox: {
    pv: 20,
    ph: 20,
    bg: 'WHITE',
    borderTopWidth: 1,
    flexDirection: 'row',
    borderColor: 'BORDER_COLOR',
    borderRadius: 4,
  } as BoxProps,
  nameText: {
    fontFamily: 'JioType-Black',
    color: 'BLACK_21',
    fontSize: 18,
  } as TextProps,
  nameOutline: {
    fontWeight: '700',
    color: 'WHITE',
    fontSize: 18,
  } as TextProps,
  labelText: (isLogout: boolean) =>
    ({
      fontWeight: '600',
      fontSize: 16,
      color: isLogout ? 'ERROR' : 'BLACK_21',
    } as TextProps),
  labelTextHeader: {
    fontWeight: '600',
    color: 'BLACK',
  } as TextProps,
  midText: {
    fontFamily: 'JioType-Medium',
    color: 'BLACK_21',
    fontSize: 14,
    lineHeight: 20,
  } as TextProps,
  descriptionText: {
    fontFamily: 'JioType-Medium',
    color: 'PRIMARY_GREY',
    fontSize: 14,
    lineHeight: 20,
  } as TextProps,
  buttonBox: {
    flexDirection: 'row',
    justify: 'space-between',
    bg: 'WHITE',
    pv: 20,
    ph: 18,
    underlayColor: 'LIGHTEST_GREY',
    m: 0,
    borderColor: 'LIGHTEST_GREY',
    borderRadius: 2,
  } as BoxProps,
  iconContainer: {
    height: 55,
    width: 55,
    borderRadius: 60,
    bg: 'ORANGE',
    ...shadowStyle,
    alignItems: 'center',
    justify: 'center',
  } as BoxProps,

  alertOutercontainer: {
    // justifyContent: 'center',
    // alignItems: 'center',
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 20,
    backgroundColor: 'WHITE',
    borderColor: 'GREY_1_SEPARATOR',
    borderWidth: 1,
    borderRadius: 8,
    shadowColor: 'GRAY_SHADOW',
    shadowOffset: {
      width: 0,
      height: 10,
    },
    shadowOpacity: 1,
    shadowRadius: 16,
    minHeight: 144,
  } as BoxProps,
  approveTitlesBox: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    w: '95%',
  } as BoxProps,
  titlesBox: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    paddingHorizontal: 24,
    paddingTop: 16,
  } as BoxProps,
  buttonsBox: (isSubtitlePresent: boolean, isCancelType: boolean) =>
    ({
      flexDirection: 'row',
      justifyContent: isCancelType ? 'flex-end' : 'center',
      marginTop: isSubtitlePresent ? 16 : 20,
      alignSelf: isCancelType ? 'flex-end' : 'center',
      paddingBottom: isCancelType ? 0 : isSubtitlePresent ? 16 : 0,
    } as BoxProps),
  title: (isCancelType: boolean) =>
    ({
      fontSize: 14,
      lineHeight: 23,
      fontWeight: '600',
      color: 'BLACK',
      textAlign: isCancelType ? 'left' : 'center',
    } as TextProps),
  subTitle: (isCancelType: boolean) =>
    ({
      fontWeight: '700',
      fontSize: 12,
      color: 'LIGHT_BLACK',
      type: 'h4Bold',
      lineHeight: 21,
      textAlign: isCancelType ? 'left' : 'center',
    } as TextProps),
  cancelBtn: {
    minWidth: 100,
    height: 35,
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 20,

    backgroundColor: 'PRIMARY',
    borderRadius: 8,
    underlayColor: 'PRIMARY',
  } as BoxProps,
  approveBtn: (isErrorTypeButton: boolean, isCancelType: boolean) =>
    ({
      minWidth: 100,
      height: 35,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 8,
      underlayColor: 'WHITE',
      backgroundColor: 'WHITE',
      shadowColor: 'GREY_MATTE',
      borderWidth: 1,
      borderColor: isCancelType ? 'LIGHTEST_GREY' : isErrorTypeButton ? 'ERROR' : 'PRIMARY',
      shadowOffset: {
        width: 1,
        height: 1,
      },
      shadowOpacity: 0.6,
      shadowRadius: 3,
      elevation: 1,
    } as BoxProps),
  approvetopBox: {
    flexDirection: 'row',
  } as BoxProps,
  screenLockView: {
    bg: customTheme.colors.JIO_PRIMARY as ColorOptions,
    paddingVertical: 24,
    flexDirection: 'row',
    paddingHorizontal: 20,
    justifyContent: 'space-between',
    overflow: 'hidden',
    borderRadius: 8,
    ...shadowStyle,
  } as BoxProps,
  screenlockText: {
    fontWeight: '700',
    fontSize: 16,
    color: 'WHITE',
    lineHeight: 22,
    textAlign: 'left',
  } as TextProps,
  lockBackground: {
    height: 80,
    position: 'absolute',
    alignSelf: 'center',
    width: 80,
    borderRadius: 40,
    bg: customTheme.colors.JIO_PRIMARY_ALPHA as ColorOptions,
    align: 'center',
    justifyContent: 'center',
  } as BoxProps,
  lockBackgroundOuter: {
    height: 130,
    position: 'absolute',
    right: -15,
    alignSelf: 'center',
    width: 130,
    borderRadius: 80,
    bg: customTheme.colors.BLUE_LIGHT_ALPHA as ColorOptions,
    align: 'center',
    justifyContent: 'center',
  } as BoxProps,
  lockBackgroundInner: {
    bg: customTheme.colors.JIO_SECONDARY_ALPHA as ColorOptions,
    height: 43,
    position: 'absolute',
    alignSelf: 'center',
    width: 43,
    borderRadius: 40,
    align: 'center',
    justifyContent: 'center',
  } as BoxProps,
  lockViewWrapper: {
    padding: 20,
    paddingTop: 10,
    underlayColor: 'WHITE',
    bg: 'WHITE',
  } as BoxProps,
  midBox: (isMobile: boolean) =>
    ({
      bg: 'WHITE',
      maxHeight: isMobile ? undefined : '90%',
      borderRadius: 4,
      minWidth: isMobile ? undefined : 450,
    } as BoxProps),
  closeIcon: {
    alignSelf: 'flex-end',
    marginRight: 8,
  } as BoxProps,
}

export { styles }
